import { HttpErrorResponse } from "@angular/common/http";
import {
  ErrorHandler,
  inject,
  Injectable,
  isDevMode,
  NgZone
} from "@angular/core";
import { PrefixLabel } from "../../../shared/types/prefix-label.type";
import { SnackbarNotificationService } from "../../modules/snackbar-notification/services/snackbar-notification/snackbar-notification.service";

@Injectable({
  providedIn: "root"
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly zone = inject(NgZone);
  private readonly snackbarNotificationService = inject(
    SnackbarNotificationService
  );

  handleError(error: unknown): void {
    // HTTP error
    if (error instanceof HttpErrorResponse) {
      return this.zone.run(() => {
        let errorMessage = error.message;

        if (error.error?.message) {
          errorMessage = `${PrefixLabel.BACKEND_ERRORS}${error.error.message}`;
        }

        this.snackbarNotificationService.error(errorMessage);
      });
    }

    // Application error. Should never happen otherwise it means there is some logic error or unhandled error cases
    if (error instanceof Error) {
      console.error(error);
      return this.zone.run(() => {
        let message = `${PrefixLabel.FRONTEND_ERRORS}GENERIC_ERROR`;

        if (isDevMode()) {
          // Show real error only in non-production environments
          message = error.message;
        }

        this.snackbarNotificationService.error(message);
      });
    }

    // Default
    console.error(error);
  }
}
